import * as dayjs from 'dayjs';
import * as isoWeek from 'dayjs/plugin/isoWeek';
import * as weekday from 'dayjs/plugin/weekday';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import * as isLeapYear from 'dayjs/plugin/isLeapYear';
import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import * as isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import * as calendar from 'dayjs/plugin/calendar';
import * as updateLocale from 'dayjs/plugin/updateLocale';
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import * as duration from 'dayjs/plugin/duration';
import * as isBetween from 'dayjs/plugin/isBetween';
import * as quarterOfYear from 'dayjs/plugin/quarterOfYear';
import * as advancedFormat from 'dayjs/plugin/advancedFormat';
import * as localeData from 'dayjs/plugin/localeData';
import * as relativeTime from 'dayjs/plugin/relativeTime';

import 'dayjs/locale/ru';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/pt';
import 'dayjs/locale/fr';


export function configureDayjs (): void {
	dayjs.extend(isoWeek);
	dayjs.extend(weekday);
	dayjs.extend(utc);
	dayjs.extend(timezone);
	dayjs.extend(isLeapYear);
	dayjs.extend(isSameOrBefore);
	dayjs.extend(isSameOrAfter);
	dayjs.extend(customParseFormat);
	dayjs.extend(calendar);
	dayjs.extend(updateLocale);
	dayjs.extend(localizedFormat);
	dayjs.extend(duration);
	dayjs.extend(isBetween);
	dayjs.extend(quarterOfYear);
	dayjs.extend(advancedFormat);
	dayjs.extend(localeData);
	dayjs.extend(relativeTime);
}

configureDayjs();
export { dayjs };
